import {
  AzureCloudInstance,
  BrowserCacheLocation,
  Configuration,
  PublicClientApplication,
} from "@azure/msal-browser"

const configuration: Configuration = {
  auth: {
    clientId: "55dba566-9ec4-46d3-aff8-08ab0e6a75ee",
    azureCloudOptions: {
      azureCloudInstance: AzureCloudInstance.AzurePublic,
      tenant: "372ee9e0-9ce0-4033-a64a-c07073a91ecd",
    },
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
}

let msalInstance: PublicClientApplication | null = null

export const getMsalInstance = () => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(configuration)
  }
  return msalInstance
}
